import "./App.css";
import Home from "./Routes/Home/Home";
import 'swiper/swiper-bundle.min.css';

function App() {
  return <Home />;
}

export default App;
